import { render } from "./QRCodeDisplay.vue?vue&type=template&id=1fe49f32&scoped=true"
import script from "./QRCodeDisplay.vue?vue&type=script&lang=js"
export * from "./QRCodeDisplay.vue?vue&type=script&lang=js"

import "./QRCodeDisplay.vue?vue&type=style&index=0&id=1fe49f32&scoped=true&lang=css"

import exportComponent from "C:\\Users\\phili\\work\\dingsda\\dingsda_2mex_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe49f32"]])

export default __exports__